import { observer } from "mobx-react";
import React, { useMemo, useCallback } from "react";
import { useDrop } from "react-dnd";
import { FormattedMessage } from "react-intl";
import { isCurrentDateTimeGreater } from "../../../constants/constants";
import moment from "moment";
import { Tooltip } from "react-bootstrap";

interface Props {
  key: string;
  day: any;
  time: string;
  children: React.ReactNode;
  staffId: number;
  staffName: string;
  type?: string;
  onDropEvent: (
    toDay: string,
    toTime: string,
    data: any,
    staffId: number,
    staffName: any,
    area: "Outer" | "Inner",
    day: any
  ) => void;
  onClick?: () => void;
  openBreakModal?: () => void;
  openReservationWindow: (params: {
    Time: string;
    StaffId: number;
    Date: string;
  }) => void;
}

const DroppableCell: React.FC<Props> = ({
  key,
  day,
  type,
  time,
  children,
  staffId,
  staffName,
  onDropEvent,
  openBreakModal,
  openReservationWindow,
}) => {
  const formattedDay = useMemo(
    () => moment(day.props["data-index"]).format("YYYY-MM-DD"),
    [day]
  );

  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: "EVENT",
      drop: (item: { data: any; area: "Outer" | "Inner"; day: any }) => {
        onDropEvent(formattedDay, time, item.data, staffId, staffName, item.area, day);
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [formattedDay, time, onDropEvent, staffId, staffName, day]
  );

  const handleReservationClick = useCallback(() => {
    // if (isCurrentDateTimeGreater(formattedDay, time)) return;
    openReservationWindow({ Time: time, StaffId: staffId, Date: formattedDay });
  }, [formattedDay, time, staffId, openReservationWindow]);

  const isWeeklyView = day?.props["data-role"] === "weekly";
  const isDisabled = false;
  
  // useMemo(
  //   () => 
  //     isCurrentDateTimeGreater(formattedDay, time),
  //   [formattedDay, time]
  // );

  return (
    <>
    <div
      data-label={`DRPPBLE-RES-EMPTY-${formattedDay}-${time}-IN-${staffId}`}
      ref={drop}
      className={`minute-cell-dropdown dropend position-relative ${isOver ? "highlight" : ""}`}
      key={key}
    >
      {children}

      <a
        role="button"
        id="actionDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        className="dragable-cell-action"
      >
        {/* {type} */}
      </a>

      <ul className="dropdown-menu" aria-labelledby="actionDropdown">
        <li>
          <button
            className={`dropdown-item ${isDisabled ? "disabled" : ""}`}
            onClick={handleReservationClick}
            disabled={isWeeklyView && staffId == -1 ? true : isDisabled}
          >
            <i className="bi bi-calendar-check-fill me-2"></i>
            <FormattedMessage id="add_reservation" />
          </button>
        </li>
        <li>
          <button
            className={`dropdown-item ${isDisabled ? "disabled" : ""}`}
            onClick={openBreakModal}
            disabled={isDisabled}
          >
            <i className="bi bi-cup-hot-fill me-2"></i>
            <FormattedMessage id="add_break" />
          </button>
        </li>
      </ul>
    </div>
    <Tooltip placement="top">
          <i className="bi bi-clock"></i> {time}
        </Tooltip>
        </>
  );
};
export default observer(DroppableCell);

